// TICKET — numbered stub accordion. Each question is a ticket card with a
// perforated (dashed) numbered stub on the left. Accent-tinted stub, mono
// numbering, smooth height animation via the shared accordion runtime.
function itemHtml(ctx, it) {
    return `<div class="fq-acc">
  <div class="fq-num" aria-hidden="true">${it.num}</div>
  <div class="fq-main">
    <button class="fq-qbtn" type="button" aria-expanded="false" aria-controls="p-${it.idx}">
      <span>${it.q}</span>
      ${ctx.showIcon ? ctx.icon : ''}
    </button>
    <div class="fq-panel" id="p-${it.idx}" role="region"><div><div class="fq-a">${it.aHtml}</div></div></div>
  </div>
</div>`;
}
const ticket = {
    id: 'ticket',
    name: 'Ticket',
    tag: 'Numbered stubs',
    styleTag: 'Playful',
    description: 'Each question is a ticket with a perforated, numbered stub. A friendly accordion with just enough character to be remembered.',
    layout: 'accordion',
    defaultAccent: '#d97706',
    darkDefault: false,
    catSupport: 'none',
    features: ['accordion'],
    render(ctx) {
        const html = `<div class="fq-wrap">
  <h2 class="fq-title">${ctx.title}</h2>
  ${ctx.subtitle ? `<p class="fq-sub">${ctx.subtitle}</p>` : ''}
  <div class="fq-list">
${ctx.items.map((it) => itemHtml(ctx, it)).join('\n')}
  </div>
</div>`;
        const css = `
.FQM .fq-wrap{max-width:680px;margin:0 auto}
.FQM .fq-title{margin:0 0 8px;font-family:${ctx.v.head};font-size:32px;font-weight:650;line-height:1.12;letter-spacing:-0.015em;color:${ctx.v.ink}}
.FQM .fq-sub{margin:0 0 26px;font-size:15.5px;line-height:1.6;color:${ctx.v.sub}}
.FQM .fq-list{display:flex;flex-direction:column;gap:12px}
.FQM .fq-acc{display:flex;background:${ctx.v.card};border:1px solid ${ctx.v.border};border-radius:${ctx.v.radiusCard};overflow:hidden}
.FQM .fq-num{flex:0 0 60px;display:grid;place-items:center;border-right:2px dashed ${ctx.v.border};background:${ctx.v.soft};font-family:${ctx.v.mono};font-size:15px;font-weight:700;color:${ctx.v.accent}}
.FQM .fq-main{flex:1;min-width:0}
.FQM .fq-qbtn{display:flex;width:100%;align-items:center;justify-content:space-between;gap:14px;padding:17px 18px}
.FQM .fq-qbtn>span{font-size:16px;font-weight:500;line-height:1.4;color:${ctx.v.ink}}
.FQM .fq-qbtn .fq-ic{font-size:12px;color:${ctx.v.accent}}
.FQM .fq-a{padding:0 18px 18px;font-size:15px;line-height:1.6;color:${ctx.v.sub}}
`;
        return { html, css };
    },
};
export default ticket;
